import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, } from 'react';
import { toast as reactHotToast, } from 'react-hot-toast';
import classNames from 'classnames';
import DToast from '../DToast/DToast';
import DIcon from '../DIcon';
import { useDContext } from '../../contexts';
export default function useDToast() {
    const { iconMap: { xLg, }, } = useDContext();
    const toast = useCallback((data, toastProps) => {
        if (typeof data === 'function') {
            return reactHotToast.custom(data, toastProps);
        }
        const { title, description, icon, closeIcon, timestamp, color, } = data;
        return reactHotToast.custom(({ id, visible }) => {
            if (!visible) {
                return null;
            }
            if (!description) {
                return (_jsx(DToast, { className: classNames({
                        [`toast-${color}`]: !!color,
                    }, 'show'), children: _jsxs(DToast.Body, { children: [icon && (_jsx(DIcon, { className: "toast-icon", icon: icon })), _jsx("p", { className: "toast-title", children: title }), _jsx("button", { type: "button", className: "d-close align-self-center", "aria-label": "Close", onClick: () => reactHotToast.dismiss(id), children: _jsx(DIcon, { icon: closeIcon || xLg }) })] }) }));
            }
            return (_jsxs(DToast, { className: classNames({
                    [`toast-${color}`]: !!color,
                }, 'show'), children: [_jsxs(DToast.Header, { children: [icon && (_jsx(DIcon, { className: "toast-icon", icon: icon })), _jsx("p", { className: "toast-title", children: title }), timestamp && (_jsx("small", { className: "toast-timestamp", children: timestamp })), _jsx("button", { type: "button", className: "d-close align-self-center", "aria-label": "Close", onClick: () => reactHotToast.dismiss(id), children: _jsx(DIcon, { icon: closeIcon || xLg }) })] }), _jsx(DToast.Body, { children: _jsx("span", { children: description }) })] }));
        }, toastProps);
    }, [xLg]);
    return {
        toast,
    };
}
//# sourceMappingURL=useDToast.js.map